import { flow, getOr } from 'lodash/fp';
import config from '../helpers/config';
import clearDesignsWhere from './clearDesignsWhere';

const modePredictateToRemove = {
  chuck: getOr(false, 'attributes.isMandi'),
  mandi: flow(
    getOr(false, 'attributes.isMandi'),
    it => !it,
  ),
};

const clearDesignsByMode = () => (
  (dispatch) => {
    dispatch(clearDesignsWhere(modePredictateToRemove[config.estimatebuilderMode]));
  }
);
export default clearDesignsByMode;

